// extracted by mini-css-extract-plugin
export var fadeInOut = "_3i-3";
export var icon = "_3i-4";
export var savedIndicator = "_3i-2";
export var savingIndicator = "_3i-0";
export var spin = "_3i-1";